import { type FC } from 'react'
import { useIntl } from 'react-intl'

import { Skeleton } from 'base-ui'

import {
  type CrossSellProductPricePropsEnhancedWithCompetera,
  useCompeteraPriceIfNeeded,
} from '../../../experiments/competera-experiment/useCompeteraPriceIfNeeded'
import { useGlobalConfigContext } from '../../../global-config'
import { TENANT } from '../../../tenant'
import { crossSellGetFormattedPrice } from '../../crossSellGetFormattedPrice'

export const CrossSellProductPrice: FC<
  CrossSellProductPricePropsEnhancedWithCompetera
> = ({ product }) => {
  const { tenant } = useGlobalConfigContext()
  const intl = useIntl()

  const { newBasePrice, price } = useCompeteraPriceIfNeeded(product)

  if (!product) {
    return (
      <div className="min-h-[calc(var(--type-scale-l-line-height)+var(--type-scale-s-line-height)+var(--type-scale-s-line-height))]">
        <Skeleton className="mx-auto w-4/5" />
      </div>
    )
  }

  return (
    <div className="flex flex-col">
      <span className="flex flex-col">
        <span className="min-h-[var(--type-scale-s-line-height)] whitespace-nowrap text-dark-primary-strong line-through">
          {product.reduced === 'true' &&
            crossSellGetFormattedPrice(product.oldprice, intl, {
              // on IT superscript is not in response, we need to force adding it for oldprice
              isItalianStrikethrough: tenant === TENANT.IT,
            })}
        </span>
        <span className="whitespace-nowrap text-2xl font-bold leading-l text-dark-brand">
          {crossSellGetFormattedPrice(price, intl)}
        </span>
      </span>
      <span className="min-h-[var(--type-scale-s-line-height)] text-s text-dark-primary-strong">
        {crossSellGetFormattedPrice(newBasePrice, intl)}
      </span>
    </div>
  )
}
